<template>
    <el-dialog
            :visible.sync="visible"
            :before-close="handleClose"
            :title="title"
            width="750px">
        <el-button slot="footer" type="primary" icon="el-icon-s-platform" @click="upsert">
            儲存
        </el-button>
        <el-form label-width="60px" :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="員編" prop="employeeId">
                <el-input v-model="ruleForm.employeeId" :disabled="type==='update'"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="employeeName">
                <el-input v-model="ruleForm.employeeName"></el-input>
            </el-form-item>
            <el-form-item label="部門" prop="department">
                <el-input v-model="ruleForm.department"></el-input>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

    export default {
        name: "CrudEmployee",
        props: {
            type: String, // add . update
            employee: Object,
        },
        created() {

            if (this.type === 'update') {

                this.ruleForm.employeeId = this.employee.employeeId;
                this.ruleForm.employeeName = this.employee.employeeName;
                this.ruleForm.department = this.employee.department;

            } else if (this.type === 'add') {

                this.ruleForm.employeeId = '';
                this.ruleForm.employeeName = '';
                this.ruleForm.department = '';
            }
        },
        methods: {
            add() {
                this.$emit('add', {
                    employeeId: this.ruleForm.employeeId,
                    employeeName: this.ruleForm.employeeName,
                    department: this.ruleForm.department,
                });
            },
            update() {
                this.$emit('update', {
                    employeeId: this.ruleForm.employeeId,
                    employeeName: this.ruleForm.employeeName,
                    department: this.ruleForm.department,
                });
            },
            upsert() {

                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.type === 'add' ? this.add() : this.update()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            handleClose() {
                this.$emit('handleClose');
            }
        },
        data() {

            return {
                visible: true,
                ruleForm: {
                    employeeId: '',
                    employeeName: '',
                    department: '',
                },
                rules: {
                    employeeId: [
                        {required: true, message: '員工編號為必填欄位', trigger: 'change'},
                        {max: 8, message: '員工編號長度至多8碼', trigger: 'change'}
                    ],
                    employeeName: [
                        {required: true, message: '員工編號為必填欄位', trigger: 'change'},
                        {max: 80, message: '員工編號長度至多80碼', trigger: 'change'}
                    ],
                    department: [
                        {required: true, message: '部門為必填欄位', trigger: 'change'},
                        {max: 4, message: '部門長度至多4碼', trigger: 'change'}
                    ],
                },
            }
        },
        computed: {
            title() {

                const titleMapper = {
                    add: '新增員工',
                    update: '修改員工資料',
                };

                return titleMapper[this.type];
            }
        },
    }
</script>

<style scoped>
</style>
